import { AfterViewInit, Component, OnInit, Type, OnDestroy, ViewChild, ComponentRef, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { InsertionDirective } from './insertion.directive';
import { Subject } from 'rxjs';
import { DialogConfig } from './dialog-config';
import { DialogRef } from './dialog-ref';

@Component({
  standalone: true,
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css'],
  imports: [InsertionDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogComponent implements OnInit, AfterViewInit, OnDestroy  {

  private readonly _onClose = new Subject<any>();
  public componentRef?: ComponentRef<any>;
  public childComponentType?: Type<any>;
  public data?: any;
  public onClose = this._onClose.asObservable();

  @ViewChild(InsertionDirective) insertionPoint!: InsertionDirective;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private dialogRef: DialogRef,
    public config: DialogConfig,
  ) {}

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    if (this.childComponentType) {
      this.loadChildComponent(this.childComponentType);
    }
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  onOverlayClicked(evt: MouseEvent) {
    evt.stopPropagation();
    this.dialogRef.close(false);
  }

  onDialogClicked(evt: MouseEvent) {
    evt.stopPropagation();
  }

  closeDialog(): void {
    this.dialogRef.close(false);
  }

  loadChildComponent(componentType: Type<any>) {
    if (!this.insertionPoint) return;
    const viewContainerRef = this.insertionPoint.viewContainerRef;
    viewContainerRef.clear();

    this.componentRef = viewContainerRef.createComponent(componentType);
    if (this.data && this.componentRef.instance) {
      this.componentRef.instance.config = { data: this.data };
      Object.assign(this.componentRef.instance, this.data);
    }
  }

}
